const createLogger = ({ loggingEnabled }) => {
  const filter = fn => (...args) => {
    if (loggingEnabled) {
      return fn(...args);
    }
  };

  return {
    group: filter((label) => {
      console.group(label);
    }),
    groupEnd: filter(() => console.groupEnd()),
    log: filter((...args) => console.log(...args)),
    printJson: filter(o => console.log(JSON.stringify(o, null, '  '))),
  };
};


export default createLogger;
